<div fxLayout>
  <sbnb-subnav class="subnav__semi-reduced-padding">
    <sbnb-back-button></sbnb-back-button>

    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'gx-log-detail'"></sbnb-helptext-wrapper>

    <sbnb-log-detail-sidebar *ngIf="logData" [log]="logData"></sbnb-log-detail-sidebar>

    <div style="margin-top: 24px">
      <button class="button__small button__secondary" fxFlex mat-flat-button (click)="reportProblem()">
        Report a problem
      </button>
    </div>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs class="block sbnbDesktop:hidden"></sbnb-page-header>
    </app-feature-flag-tabs>

    <div *ngIf="loading" class="table__no-items">Loading log details...</div>

    <div *ngIf="!loading && logData" class="log-container log-{{ logData.send_status }}">
      <div class="log-hero log-hero-{{ logData.send_status }} p-3 md:p-6">
        <div class="flex items-center gap-2 mb-2 flex-col md:flex-row">
          <h3>{{ logData.title }}</h3>

          <div class="flex md:flex-1 justify-between items-center gap-4">
            <sbnb-log-send-status [log]="logData"></sbnb-log-send-status>
            <sbnb-button
              [fullWidth]="true"
              *ngIf="logData.thread?.uuid"
              [routerLink]="['/inbox/thread/' + logData.thread.uuid]"
              type="secondary"
              size="mini">
              Go to conversation
            </sbnb-button>
          </div>
        </div>

        <div>
          <sbnb-log-hero-item
            *ngIf="
              reason?.cancel?.has_cancel_reason ||
              reason?.timing?.has_timing_reason ||
              reason?.failure?.has_failure_reason
            "
            [info]="reason?.cancel?.has_cancel_reason || reason?.timing?.has_timing_reason"
            [warning]="reason?.failure?.has_failure_reason">
            <div fxLayout="row wrap" fxLayoutGap="8px" fxLayoutAlign="start center">
              <span
                *ngIf="reason.cancel?.has_cancel_reason"
                [innerHTML]="
                  reason.cancel.description
                    | transloco
                      : {
                          user: reason.cancel.user,
                          scheduled_for_label: logData.scheduled_for_label,
                          cancelled_at_label: logData.cancelled_at_label,
                          platform: reason.cancel.platform,
                          reservation: reason.cancel.reservation,
                          property: reason.cancel.property,
                          cancel_description: reason.cancel.cancel_description
                        }
                "></span>
              <span
                *ngIf="reason.failure?.has_failure_reason"
                [innerHTML]="
                  reason.failure.description
                    | transloco
                      : {
                          user: reason.failure.user,
                          scheduled_for_label: logData.scheduled_for_label,
                          platform: reason.failure.platform,
                          reservation: reason.failure.reservation,
                          property: reason.failure.property,
                          failure_description: reason.failure.failure_description
                        }
                "></span>
              <span
                *ngIf="reason.timing?.has_timing_reason"
                [innerHTML]="
                  reason.timing.description
                    | transloco
                      : {
                          user: reason.timing.user,
                          scheduled_for_label: logData.scheduled_for_label,
                          platform: reason.timing.platform,
                          reservation: reason.timing.reservation,
                          property: reason.timing.property
                        }
                "></span>
            </div>
          </sbnb-log-hero-item>

          <!-- Don't allow event messages be edited -->
          <sbnb-log-hero-item
            *ngIf="logData.send_status === 'scheduled' && logData.guest?.name && logData.type == 'activity'"
            [pending]="true">
            This {{ getTypeLabel() }} will be sent to
            <strong>{{ logData.guest?.name }}</strong>
            at
            <strong>{{ logData.scheduled_for_label }}</strong>
          </sbnb-log-hero-item>
          <!-- end don't allow event messages be edited -->

          <sbnb-log-hero-item *ngIf="logData.send_status === 'sent' && logData.guest?.name && logData.sent_at_label">
            This {{ getTypeLabel() }} has been sent to
            <strong>{{ logData.guest?.name }}</strong>
            on
            <strong>{{ logData.sent_at_label }}</strong>
          </sbnb-log-hero-item>

          <sbnb-log-hero-item
            *ngIf="logData.send_status === 'scheduled' && logData.guest?.name && logData.type != 'activity'"
            [pending]="true">
            <div class="flex flex-wrap gap-2 items-center">
              <span>
                This message will be sent to
                <strong>{{ logData.guest.name }}</strong>
              </span>
              <div class="flex items-center gap-2">
                at
                <span class="datepicker-badge" [matMenuTriggerFor]="dateMenu" #trigger="matMenuTrigger">
                  {{ this.logData.scheduled_day | date: 'mediumDate' }}
                </span>
                <sbnb-time-picker
                  [hours]="this.logData.scheduled_time_hours"
                  [minutes]="this.logData.scheduled_time_minutes"
                  (timeUpdated)="newTimeSelected($event)"></sbnb-time-picker>
                <span>{{ logData.scheduled_timezone }}</span>
              </div>
            </div>

            <mat-menu #dateMenu="matMenu" class="filters__cdk-menu">
              <div>
                <sbnb-date-picker
                  [numMonths]="1"
                  [startDate]="logData.scheduled_day"
                  [rangeSelect]="false"
                  [checkInOutStyling]="false"
                  [showDurationLabels]="false"
                  (click)="$event.stopPropagation()"
                  (datesSelected)="trigger.closeMenu(); newDateSelected($event)"></sbnb-date-picker>
              </div>
            </mat-menu>
          </sbnb-log-hero-item>

          <sbnb-log-hero-item *ngIf="logData.custom_timing" [positive]="true">
            The scheduled send time of this message has been manually modified.
          </sbnb-log-hero-item>

          <sbnb-log-hero-item *ngIf="logData.send_status === 'prepared' && logData.guest?.name" [pending]="true">
            This {{ getTypeLabel() }} was prepared for your review at
            <strong>{{ logData.created_at_label }}</strong>
            for
            <strong>{{ logData.guest?.name }}</strong>
            .
          </sbnb-log-hero-item>

          <sbnb-log-hero-item [positive]="false" *ngIf="logData.send_status === 'failed'">
            This {{ getTypeLabel() }} could not be sent to
            <strong>{{ logData.guest?.name }}</strong>
            on
            <strong>{{ logData.scheduled_for_label }}</strong>
          </sbnb-log-hero-item>

          <sbnb-log-hero-item [positive]="false" *ngIf="logData.send_status === 'cancelled'">
            This {{ getTypeLabel() }} to
            <strong>{{ logData.guest?.name }}</strong>
            was cancelled on
            <strong>{{ logData.cancelled_at_label }}</strong>
            .
          </sbnb-log-hero-item>

          <sbnb-log-hero-item [info]="true" *ngIf="logData.type !== 'answer'">
            {{ logData.languages }}
          </sbnb-log-hero-item>

          <sbnb-log-hero-item *ngIf="logData.activity && logData.activity_rule_name">
            This question was answered as part of the response to the event:
            <strong>{{ logData.activity_rule_name }}</strong>
          </sbnb-log-hero-item>

          <sbnb-log-hero-item *ngIf="logData.send_status === 'detected'">
            {{ 'CORE.PRODUCT_NAME' | transloco }} detected a question from {{ logData.guest.name }}, but you don't have
            a rule setup to answer it.
          </sbnb-log-hero-item>

          <sbnb-log-hero-item [info]="true" *ngIf="logData.last_edit">
            <div fxLayout="row wrap" fxLayoutGap="8px" fxLayoutAlign="start center">
              <span>
                This was last edited on
                <strong>{{ logData.last_edit?.edited_at_label }}</strong>
                by
                <strong>{{ logData.last_edit?.user?.first_name }} {{ logData.last_edit?.user?.last_name }}</strong>
              </span>
            </div>
          </sbnb-log-hero-item>

          <sbnb-log-hero-item
            [info]="true"
            *ngIf="
              logData.ai_improvement?.message &&
              logData.ai_improvement?.edited === false &&
              logData.ai_improvement?.rejected === false
            ">
            <span>This message was improved by Guest Experience AI automatically.</span>
            <img
              style="margin-left: 6px; display: inline-block"
              src="/assets/iconography/magic.svg"
              alt="AI improved icon"
              matTooltip="Message set to improve with AI"
              width="16" />
            <span
              *ngIf="
                logData.send_status === 'scheduled' &&
                !logData.activity &&
                logData.ai_improvement?.rejected === false &&
                !isRejectingAiImprovement
              "
              class="ai-undo clickable"
              (click)="undoAiImprovement()">
              Undo improvements
            </span>
          </sbnb-log-hero-item>
        </div>
      </div>

      <ng-container *ngIf="logData.type === 'answer' && logData.question">
        <h2>Question</h2>
        <div class="log-message log-message-ro" [innerHTML]="logData.question"></div>
      </ng-container>

      <ng-container *ngIf="logData.type === 'answer' && logData.question && logData.send_status !== 'detected'">
        <h2>Reply</h2>
      </ng-container>

      <div fxLayout fxLayoutGap="48px" fxLayout.lt-md="column" fxLayoutGap.lt-md="12px">
        <div
          class="log-message"
          [class.log-message-ro]="
            (logData.send_status !== 'scheduled' && logData.send_status !== 'prepared') || logData.activity
          "
          fxFlex
          [class.hidden]="logData.prepared_message === 'DELETE' || logData.send_status === 'detected'">
          <textarea
            [class.hidden]="logData.prepared_message === 'DELETE'"
            cdkTextareaAutosize
            cdkAutosizeMinRows="5"
            style="overflow-y: hidden"
            [ngModel]="logData.prepared_message"
            (ngModelChange)="dirty = true; logData.prepared_message = $event"
            [disabled]="
              (logData.send_status === 'scheduled' || logData.send_status === 'prepared') && !logData.activity
                ? null
                : ''
            "></textarea>
        </div>
      </div>
      <div *ngIf="type === 'reviews'">
        <sbnb-review-ratings
          [review]="logData"
          [readOnly]="logData.send_status !== 'scheduled'"
          (click)="logData.send_status === 'scheduled' ? (dirty = true) : null"></sbnb-review-ratings>
      </div>

      <div fxLayoutAlign="end center" style="margin-top: 24px" fxLayoutGap="24px">
        <button
          *ngIf="logData.send_status === 'scheduled' && !logData.activity"
          mat-flat-button
          class="button__text !text-rose-darker"
          [disabled]="cancelling || sending || saving"
          (click)="cancelClicked()">
          <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
            <sbnb-icon icon="not-allowed"></sbnb-icon>
            <span>{{ cancelling ? 'Cancelling...' : "Don't send" }}</span>
          </div>
        </button>

        <div *ngIf="logData.send_status === 'scheduled'" fxFlex></div>

        <button
          *ngIf="logData.send_status === 'cancelled' && logData.restore && (type === 'scheduled' || type === 'reviews')"
          mat-flat-button
          [disabled]="restoring"
          class="button__primary bg-grass-darker"
          (click)="restoreClicked()">
          {{ restoring ? 'Restoring...' : 'Restore' }}
        </button>

        <button
          *ngIf="
            (logData.send_status === 'scheduled' || logData.send_status === 'prepared') &&
            !isBadReview() &&
            !logData.activity
          "
          mat-flat-button
          [disabled]="saving || sending || cancelling"
          class="button__secondary"
          (click)="sendMessage()">
          {{ sending ? 'Sending...' : 'Send now' }}
        </button>

        <button
          *ngIf="logData.send_status === 'scheduled' && !logData.activity"
          mat-flat-button
          [disabled]="saving || sending || cancelling"
          class="button__primary bg-grass-darker"
          (click)="sendMessage(false)">
          {{ saving ? 'Saving...' : 'Save' }}
        </button>
      </div>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [title]="logData?.title">
  <sbnb-back-button></sbnb-back-button>

  <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'gx-log-detail'"></sbnb-helptext-wrapper>

  <sbnb-log-detail-sidebar *ngIf="logData" [log]="logData"></sbnb-log-detail-sidebar>

  <div style="margin-top: 24px">
    <button class="button__small button__secondary" fxFlex mat-flat-button (click)="reportProblem()">
      Report a problem
    </button>
  </div>
</sbnb-mobile-sidebar>
